import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport2400KtoAuszugStatus: 'idle',
    startReport2400KtoAuszugError: undefined as any,
    loadUserParamsReport2400KtoAuszugStatus: 'idle',
    loadUserParamsReport2400KtoAuszugError: undefined as any,

    report2400KtoAuszugList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport2400KtoAuszug = createAsyncThunk('report2400KtoAuszugSlice/startReport2400KtoAuszug', async ({ report2400KtoAuszug }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport2400KtoAuszug/`,
        prepareData(report2400KtoAuszug),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport2400KtoAuszugStatus } = getState().report2400KtoAuszugSlice
        return startReport2400KtoAuszugStatus !== 'pending'
    }
})

export const loadUserParamsReport2400KtoAuszug = createAsyncThunk('report2400KtoAuszugSlice/loadUserParamsReport2400KtoAuszug', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport2400KtoAuszug/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport2400KtoAuszugStatus } = getState().report2400KtoAuszugSlice
        return loadUserParamsReport2400KtoAuszugStatus !== 'pending'
    }
})

const Report2400KtoAuszugSlice = createSlice({
    name: 'report2400KtoAuszugSlice',
    initialState,
    reducers: {
        resetstartReport2400KtoAuszug: (state) => {
            state.job = undefined
            state.startReport2400KtoAuszugError = undefined
        },
        resetstartReport2400KtoAuszugError: (state) => {
            state.startReport2400KtoAuszugError = undefined
        },
        resetloadUserParamsReport2400KtoAuszug: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport2400KtoAuszugError = undefined
        },
        resetloadUserParamsReport2400KtoAuszugError: (state) => {
            state.loadUserParamsReport2400KtoAuszugError = undefined
        },
        removeFromReport2400KtoAuszugListById: (state, action) => {
            state.report2400KtoAuszugList = state.report2400KtoAuszugList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport2400KtoAuszugListByIds: (state, action) => {
            state.report2400KtoAuszugList = state.report2400KtoAuszugList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report2400KtoAuszugList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport2400KtoAuszugStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report2400KtoAuszugList = []
            state.startReport2400KtoAuszugStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport2400KtoAuszug.pending, (state) => {
            state.startReport2400KtoAuszugStatus = 'pending'
            state.startReport2400KtoAuszugError = undefined
        })
        builder.addCase(startReport2400KtoAuszug.fulfilled, (state, action) => {
            state.startReport2400KtoAuszugStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport2400KtoAuszug.rejected, (state, action) => {
            state.startReport2400KtoAuszugStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport2400KtoAuszugError = action.error.message
            } else {
                state.startReport2400KtoAuszugError = action.payload
            }
        })

        builder.addCase(loadUserParamsReport2400KtoAuszug.pending, (state) => {
            state.loadUserParamsReport2400KtoAuszugStatus = 'pending'
            state.loadUserParamsReport2400KtoAuszugError = undefined
        })
        builder.addCase(loadUserParamsReport2400KtoAuszug.fulfilled, (state, action) => {
            state.loadUserParamsReport2400KtoAuszugStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport2400KtoAuszug.rejected, (state, action) => {
            state.loadUserParamsReport2400KtoAuszugStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport2400KtoAuszugError = action.error.message
            } else {
                state.loadUserParamsReport2400KtoAuszugError = action.payload
            }
        })

    }
})

export const {
    resetstartReport2400KtoAuszug,
    resetstartReport2400KtoAuszugError,
    resetloadUserParamsReport2400KtoAuszug,
    resetloadUserParamsReport2400KtoAuszugError,
    removeFromReport2400KtoAuszugListById,
    removeFromReport2400KtoAuszugListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report2400KtoAuszugSlice.actions
export default Report2400KtoAuszugSlice.reducer
